import { useEffect, useMemo, useState } from "react";
import { fetchFPLData } from "../api/fplApi";

const TopStats = () => {
  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchFPLData().then((data) => {
      if (!data) return;
      if (data.elements) setPlayers(data.elements);
      if (data.teams) setTeams(data.teams);
      if (data.events) setEvents(data.events);
    }).catch(() => {});
  }, []);

  // FPL can briefly expose stale previous-season cumulative player totals during
  // the pre-season rollover. Do not present those as current-season leaders.
  const seasonHasStarted = useMemo(() => {
    if (!events.length) return false;
    return events.some((e) => e.is_current || e.finished || e.data_checked);
  }, [events]);

  const top = (key, position = null) => {
    if (!seasonHasStarted) return null;
    let list = [...players];
    if (position) list = list.filter((p) => p.element_type === position);
    return list.sort((a, b) => Number(b[key] || 0) - Number(a[key] || 0))[0] || null;
  };

  const items = [
    { label: "Top Scorer", player: top("goals_scored"), key: "goals_scored", suffix: "goals" },
    { label: "Top Assists", player: top("assists"), key: "assists", suffix: "assists" },
    { label: "Clean Sheets", player: top("clean_sheets", 1), key: "clean_sheets", suffix: "clean sheets" },
  ];

  return (
    <div>
      {!seasonHasStarted && (
        <div className="fpl-season-reset-note">
          2026/27 season stats will appear once GW1 starts. Previous-season totals are hidden.
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {items.map(({ label, player, key, suffix }) => {
          const team = player ? teams.find((t) => t.id === player.team) : null;
          return (
            <div key={label} className="fpl-stat-card">
              <div className="min-w-0 z-[1]">
                <div className="fpl-stat-label">{label}</div>
                {player ? (
                  <>
                    <div className="fpl-stat-value">{player[key]} <span>{suffix}</span></div>
                    <div className="fpl-stat-name">{player.web_name}</div>
                    <div className="fpl-stat-team">{team?.name || "Premier League"}</div>
                  </>
                ) : (
                  <>
                    <div className="fpl-stat-value">—</div>
                    <div className="fpl-stat-name">Season not started</div>
                    <div className="fpl-stat-team">Updates from GW1</div>
                  </>
                )}
              </div>
              {player && (
                <img
                  src={`https://resources.premierleague.com/premierleague25/photos/players/110x140/${player.code}.png`}
                  alt={player.web_name}
                  className="fpl-stat-photo"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopStats;
